import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';

type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        pending: {
            subtitle4: string;
        },
    },
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    infoShared1: 'Information entered into this web form will be used for verification purposes. The information will be shared with Atec-Sports.',
    infoShared2: ' ',
    requiredFields: '* Required Fields',
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: `To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States
                    and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status
                    selector of this form.<br><br>Atec-Sports uses SheerID, a trusted partner, to verify that you are a medical professional.
                    SheerID only collects information that assists in verifying your eligibility.
                    Additional information or documentation may be requested.`,
        },
        success: {
            title: 'SUCCESS',
            subtitle: 'You are now verified. Below is a one-time registration code that you will use to create an account through our VIP site. Once you have created an account, your discount will be applied automatically to all eligible items on the site. Your exclusive pricing will be available whenever you are logged in to your account.<br><br>Click CONTINUE TO ATEC to begin your registration.',
            redirectButtonText: 'CONTINUE TO ATEC',
            emailNotification: 'We will email you a copy of your registration code and a link to the website in case you\'d prefer to register and shop later. Look for an email from us (verify@sheerid.com) with all the details. Please note that your discount cannot be combined with other offers or promotions.',
            verificationOnly: 'SheerID handles verification only. Now that you\'ve been approved, please direct all questions about the promotion terms and/or code use to Atec-Sports customer service.',
        },
        pending: {
            titleCountdown: 'Processing',
            titleReview: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status. <br><br>This process may take up to {maxReviewTime}.',
            subtitle4: 'Information entered into this web form will be used for verification purposes.<br>The information will be shared with Atec-Sports.',
        },
        docUpload: {
            title: 'WE NEED YOUR MEDICAL LICENSE OR CERTIFICATE',
            subtitle: 'Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner who specializes in verifying medical professionals.',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying
                    medical professionals.<br><br>Documents are used only for verifying your medical professional status is
                    current and will be permanently deleted after review is finalized. They will not be shared with Atec-Sports.`,
            uploadInstructions: 'Upload an official document that shows:',
        },
    },
};
